<template>
  <div class="content">
    <div class="process-container">
      <div class="line-box">
        <div class="grayLine" :style="{backgroundColor:backColor}">
          <div class="colorLine" :style="{width:decimalToPercent()}">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['current', 'total', 'backColor', 'progressColor'],
  data () {
    return {
    }
  },
  methods: {
    // 小数转化百分比
    decimalToPercent () {
      let data = '100%'
      if (this.current < this.total) {
        data = ((this.current / this.total) * 100).toFixed(2) + '%'
      }
      return data
    }
  }
}
</script>

<style scoped lang="less">
.content {
  .process-container {
    align-items: center;
  }
  .bot {
    margin: 0 30px;
  }
.line-box{
  display: flex;
  height: 3.27vw;
  width: 100%;
  margin: auto;
  .grayLine {
    margin: auto;
    height: 2.45vw;
    width: 100%;
    .colorLine {
      height: 100%;
      background: linear-gradient(180deg, #BD0000 0%, #FF2E2E 26.04%, #910000 75%, #BD0000 100%),
      linear-gradient(0deg, #FFFAFA, #FFFAFA);
    ;
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/ProgressLine/progress.vue